const selectSnackbar = state => state.snackbar;

export const selectSnackbarState = state => selectSnackbar(state).state;
export const selectSnackbarOptions = state => selectSnackbar(state).options;
